import { Skeleton } from "@mui/material";
import React from "react";
import classes from "./TableSkeleton.module.css";

function TableSkeleton({ rowsCount = 10, colsCount = 5 }) {
  const rows = Array(rowsCount).fill(0);
  const cols =
    typeof colsCount === "number" ? Array(colsCount).fill(0) : colsCount;
  return (
    <>
      <style>{`
           .tr{
                all:unset;
                display:flex;
            }
                .table100 {
  --columns-to-show: ${cols?.length < 5 ? cols?.length : 5};
}
                
            `}</style>
      <div className={classes.tableBody}>
        <div
          className={`table100 table100-body js-pscroll ps ps--active-y`}
          style={{ height: "calc(100vh - 425px)" }}
        >
          <table>
            <tbody>
              {rows?.map((item, index) => (
                <tr key={index} className="tr">
                  {cols?.map((innerItem, colIndex) => (
                    <td
                      key={`${index}.${colIndex}`}
                      style={{
                        borderRight: "1px solid var(--green-v4)",
                        paddingBlock: "0px",
                        paddingInline: "10px",
                        ...(innerItem?.style ?? {}),
                      }}
                    >
                      <Skeleton
                        style={{
                          height: "36px",
                        }}
                      />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default TableSkeleton;
